import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { InputLabelPipe } from '../../../../../pipes/atyl/inputLabel.pipe'
import { FormAtylBase } from '../../../../form-atyl-base'
import { LOCALE_ID } from '@angular/core';
import { FormGroup, ValidationErrors, FormArray, FormControl } from '@angular/forms';
 
@Component({
	selector: 'atyl-form-input-number',
	templateUrl: './form-input-number.component.html',
	styleUrls: ['./form-input-number.component.scss'],
	providers: [
		{ provide: LOCALE_ID, useValue: 'us-US' },
    
    ]
})
export class FormInputNumberComponent implements OnInit {

	@Input() forminput: FormAtylBase<any>
	@Input() group: any
	@Input() isValid: boolean
	@Input() errorMessage: any
	@Input() outline: any
	@Input() disabled: boolean

	@Output() inputTyped = new EventEmitter<any>();
	label: string
	errorString: string
   
	decimals: number=2;
	  negative: number=1;
	
	constructor(
		private readonly inputLabelPipe: InputLabelPipe
	) {

	}

	ngOnInit() {
		this.label = this.inputLabelPipe.transform(this.forminput)
		this.errorString = this.errorMessage && this.errorMessage[0] ? this.errorMessage[0] : ''
		
		if (this.forminput ) {
			console.log("FormInputNumberComponent ngOnInit",this.forminput)
		    if (this.forminput.options && this.forminput.options.decimals!=undefined) {
				this.decimals=Number(this.forminput.options.decimals);
			}
			
			if (this.forminput.options && this.forminput.options.negative!=undefined) {
				this.negative=Number(this.forminput.options.negative);
			}
			
			if (this.forminput.value!=undefined) {
				console.log("FormInputNumberComponent ngOnInit value",this.decimals,this.forminput.value,Number(this.forminput.value).toFixed(this.decimals))
				this.group.get(String(this.forminput.ID)).setValue(Number(this.forminput.value).toFixed(this.decimals))
			}
				 
		}
	  }

	  //Fonction d'execution de code provenant du backoffice, trigger dès le changement de valeur du champ
	  customBehaviourHandler(customBehaviour: any) {
	    // if(customBehaviour)
	    //   eval(customBehaviour);
	    this.inputTyped.emit(customBehaviour)
	  }

	  replaceValue(newValue: any) {
		console.log("replaceValue",newValue);
	    this.group.get(String(this.forminput.ID)).setValue(Number(newValue.value));
	  }
	
	
}
